<template lang="html">
  <div class="box">
    <p class="panel-heading">
      Novo E-mail
      <router-link class="button is-small is-primary is-pulled-right" :to="{name: 'AppUsersEmailsList'}">Voltar</router-link>
      <div class="is-clearfix"></div>
    </p>
    <form>
      <div class="field">
        <label class="label">Nome Remetente</label>
        <p class="control">
          <input v-validate="'required'" class="input" type="text" placeholder="Nome Remetente" v-model="dataEmail.remetente_nome" name="nome-remetente">
        </p>
      </div>

      <div class="field">
        <label class="label">Responder Para</label>
        <p class="control has-icons-left has-icons-right">
          <input v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('responder-para')}" type="text" placeholder="Responder Para" v-model="dataEmail.responder_para" name="responder-para">
          <span class="icon is-small is-left">
            <i class="fa fa-envelope"></i>
          </span>
        </p>
      </div>

      <div class="field">
        <label class="label">Assunto</label>
        <p class="control">
          <input v-validate="'required'" class="input" type="text" placeholder="Assunto" v-model="dataEmail.assunto" name="assunto">
        </p>
      </div>

      <div class="field">
        <label class="label">Anexo - Apenas Um</label>
        <p class="control">
          <input class="input" type="file" placeholder="Anexo" @change="fileChanged">
        </p>
      </div>


      <div class="field">
        <label class="label">Destinatário</label>
        <p class="control has-icons-left has-icons-right">
          <input v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('destinatario')}" type="text" placeholder="Destinatário" v-model="dataEmail.destinatario" name="destinatario">
          <span class="icon is-small is-left">
            <i class="fa fa-envelope"></i>
          </span>
        </p>
      </div>
      <quill :options="{ theme: 'snow' }" ref="qc">
        <h2>One Ring to Rule Them All</h2>
        <p><a href="http://en.wikipedia.org/wiki/One_Ring">http://en.wikipedia.org/wiki/One_Ring</a></p>
        <p><br/></p>
        <p>Three Rings for the <em>Elven-kings</em> under the sky,</p>
        <p>Seven for the <u>Dwarf-lords</u><span> in halls of stone,</span></p>
        <p>Nine for <u>Mortal Men</u>, doomed to die,</p>
        <p>One for the <u>Dark Lord</u> on his dark throne.</p>
        <p><br/></p>
        <p><span>In the Land of Mordor where the Shadows lie.</span></p>
        <p>One Ring to <strong>rule</strong> them all, One Ring to <strong>find</strong> them,</p>
        <p>One Ring to <strong>bring</strong> them all and in the darkness <strong>bind</strong> them.</p>
        <p>In the Land of Mordor where the Shadows lie.</p>
      </quill>
      <div class="panel-block">
        <button class="button is-primary is-outlined is-fullwidth" :disabled="errors.any()" @click.prevent="sendEmail">
          Enviar E-mail
        </button>
      </div>
    </form>
    <div v-if="loading" class="sk-folding-cube">
      <div class="sk-cube1 sk-cube"></div>
      <div class="sk-cube2 sk-cube"></div>
      <div class="sk-cube4 sk-cube"></div>
      <div class="sk-cube3 sk-cube"></div>
      Aguarde..
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert2'
import Quill from 'vue-bulma-quill'
import { getUser, sendEmailUser } from './users.service'
export default {
  name: 'AppEmailsNewInfo',
  data () {
    return {
      codUser: '',
      dataEmail: {
        token: '',
        assunto: '',
        remetente_nome: '',
        responder_para: '',
        destinatario: '',
        conteudo: ''
      },
      loading: false,
      file: ''

    }
  },
  components: {
    Quill
  },
  methods: {
    sendEmail () {
      this.loading = true
      this.dataEmail.conteudo = this.$refs.qc.$el.querySelector('.ql-editor').innerHTML
      const dataEmailFile = new FormData()
      dataEmailFile.append('file', this.file)
      dataEmailFile.append('token', this.dataEmail.token)
      dataEmailFile.append('assunto', this.dataEmail.assunto)
      dataEmailFile.append('remetente_nome', this.dataEmail.remetente_nome)
      dataEmailFile.append('responder_para', this.dataEmail.responder_para)
      dataEmailFile.append('destinatario', this.dataEmail.destinatario)
      dataEmailFile.append('conteudo', this.dataEmail.conteudo)
      sendEmailUser(this.codUser, dataEmailFile)
      .then(response => {
        this.loading = false
        swal({
          title: 'Envio de E-mail!',
          text: 'E-mail enviado com sucesso!',
          type: 'success',
          showLoaderOnConfirm: true
        })
        .then(() => {
          this.$router.push({ name: 'AppUsersEmailsList' })
        })
      })
    },
    fileChanged (event) {
      this.file = event.target.files[0]
    }
  },
  mounted () {
    const codUser = this.$route.params.codUser
    getUser(codUser)
    .then(response => {
      this.codUser = response.use_codigo
      this.dataEmail.token = response.use_data.token
      this.dataEmail.remetente_nome = response.use_data.nome
      this.dataEmail.responder_para = response.use_data.email
    })
  }
}
</script>

<style lang="styl">
@import "~quill/assets/snow"

.sk-folding-cube {
  margin: 20px auto;
  width: 40px;
  height: 40px;
  top: 45%;
  left: 45%;
  position: absolute;
  -webkit-transform: rotateZ(45deg);
          transform: rotateZ(45deg);
}

.sk-folding-cube .sk-cube {
  float: left;
  width: 50%;
  height: 50%;
  position: relative;
  -webkit-transform: scale(1.1);
      -ms-transform: scale(1.1);
          transform: scale(1.1);
}
.sk-folding-cube .sk-cube:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #333;
  -webkit-animation: sk-foldCubeAngle 2.4s infinite linear both;
          animation: sk-foldCubeAngle 2.4s infinite linear both;
  -webkit-transform-origin: 100% 100%;
      -ms-transform-origin: 100% 100%;
          transform-origin: 100% 100%;
}
.sk-folding-cube .sk-cube2 {
  -webkit-transform: scale(1.1) rotateZ(90deg);
          transform: scale(1.1) rotateZ(90deg);
}
.sk-folding-cube .sk-cube3 {
  -webkit-transform: scale(1.1) rotateZ(180deg);
          transform: scale(1.1) rotateZ(180deg);
}
.sk-folding-cube .sk-cube4 {
  -webkit-transform: scale(1.1) rotateZ(270deg);
          transform: scale(1.1) rotateZ(270deg);
}
.sk-folding-cube .sk-cube2:before {
  -webkit-animation-delay: 0.3s;
          animation-delay: 0.3s;
}
.sk-folding-cube .sk-cube3:before {
  -webkit-animation-delay: 0.6s;
          animation-delay: 0.6s;
}
.sk-folding-cube .sk-cube4:before {
  -webkit-animation-delay: 0.9s;
          animation-delay: 0.9s;
}
@-webkit-keyframes sk-foldCubeAngle {
  0%, 10% {
    -webkit-transform: perspective(140px) rotateX(-180deg);
            transform: perspective(140px) rotateX(-180deg);
    opacity: 0;
  } 25%, 75% {
    -webkit-transform: perspective(140px) rotateX(0deg);
            transform: perspective(140px) rotateX(0deg);
    opacity: 1;
  } 90%, 100% {
    -webkit-transform: perspective(140px) rotateY(180deg);
            transform: perspective(140px) rotateY(180deg);
    opacity: 0;
  }
}

@keyframes sk-foldCubeAngle {
  0%, 10% {
    -webkit-transform: perspective(140px) rotateX(-180deg);
            transform: perspective(140px) rotateX(-180deg);
    opacity: 0;
  } 25%, 75% {
    -webkit-transform: perspective(140px) rotateX(0deg);
            transform: perspective(140px) rotateX(0deg);
    opacity: 1;
  } 90%, 100% {
    -webkit-transform: perspective(140px) rotateY(180deg);
            transform: perspective(140px) rotateY(180deg);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// UsersEmailsNewInfo.vue?643a33cc